import _objectSpread from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _toConsumableArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function makeResult(vat, isValid, country) {
  return {
    value: vat || undefined,
    isValid: Boolean(isValid),
    isValidFormat: country ? isVatValidToRegexp(vat, country.rules.regex).isValid : false,
    isSupportedCountry: Boolean(country),
    country: !country ? undefined : {
      name: country.name,
      isoCode: {
        short: country.codes[0],
        long: country.codes[1],
        numeric: country.codes[2]
      }
    }
  };
}

function removeExtraChars() {
  var vat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return vat.toString().toUpperCase().replace(/(\s|-|\.)+/g, '');
}

function getCountryCodes(country) {
  return [].concat(_toConsumableArray(country.codes), [country.name === 'Greece' ? 'EL' : undefined]).filter(Boolean);
}

function getCountry(vat, countriesList) {
  var _iterator = _createForOfIteratorHelper(countriesList),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var country = _step.value;
      if (startsWithCode(vat, country)) return _objectSpread({}, country);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return undefined;
}

function startsWithCode(vat, country) {
  var countryCodes = getCountryCodes(country);
  return countryCodes.filter(function (code) {
    return vat.startsWith(code);
  }).length > 0;
}

function isVatValidToRegexp(vat, regexArr) {
  var _iterator2 = _createForOfIteratorHelper(regexArr),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var regex = _step2.value;
      var isValid = regex.test(vat);
      if (isValid) return {
        isValid: true,
        regex: regex
      };
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return {
    isValid: false,
    regex: undefined
  };
}

function isVatValid(vat, country) {
  var regexpValidRes = isVatValidToRegexp(vat, country.rules.regex);
  if (!regexpValidRes.isValid || !regexpValidRes.regex) return false;
  var regexResult = regexpValidRes.regex.exec(vat);
  if (!regexResult) return false;
  return country.calcFn(regexResult[2]);
}

export function checkVAT(vat) {
  var countriesList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!vat) return makeResult(vat, false);
  var cleanVAT = removeExtraChars(vat);
  var country = getCountry(cleanVAT, countriesList);
  var isValid = country ? isVatValid(cleanVAT, country) : false;
  return makeResult(cleanVAT, isValid, country);
}